"use client";
import { useScroll, animated } from "@react-spring/web";

export default function ReadingProgress() {
  const { scrollYProgress } = useScroll();
  return (
    <div className="fixed top-0 left-0 bg-transparent h-[12px] w-screen z-50">
      <animated.div
        className="bg-yellow-400 h-[6px]"
        style={{
          width: scrollYProgress.to({
            range: [0, 1],
            output: ["0%", "100%"],
          }),
        }}
      ></animated.div>
    </div>
  );
}
